import React, { Component } from 'react';
import Header from '../../Layouts/Header'
import Footer from '../../Layouts/Footer';
import Breadcrumb from '../../Layouts/Breadcrumb';
import AuthApi from '../../Services/Authapi';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
// Removed TableComponent; using custom list UI
import swal from 'sweetalert';
import ls from 'local-storage';
import TextField from "@material-ui/core/TextField";
import AuthCheckComponent from '../../Layouts/Token';
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
import ClearIcon from "@material-ui/icons/Clear";
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';
import Popover from '@material-ui/core/Popover';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';
// import { useTheme } from '@material-ui/core/styles'; // Already imported from ThemeContext or can use from core for makeStyles
import { makeStyles, useTheme as useMuiTheme } from '@material-ui/core/styles';


import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
// Removed unused FormControl, InputLabel, Select after chip popovers replaced inputs
// Checkbox removed in favor of checkmark selection styling
import ListItemText from '@material-ui/core/ListItemText';
import Box from '@material-ui/core/Box';
import Chip from '@material-ui/core/Chip';
import FlagIcon from '@material-ui/icons/Flag';
import GroupIcon from '@material-ui/icons/Group';
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';
import EventIcon from '@material-ui/icons/Event';
import CheckIcon from '@material-ui/icons/Check';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
// Removed Backlog chip; icon no longer needed
import AddIcon from '@material-ui/icons/Add';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Divider from '@material-ui/core/Divider';
import { EditorState, RichUtils, convertToRaw } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined';
import TablePagination from '@material-ui/core/TablePagination';
import { ThemeContext } from '../../../ThemeContext';


// Custom styled Tooltip for dark mode
const DarkTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: '#1f2937',
        color: '#f3f4f6',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.3)',
        fontSize: 12,
        border: '1px solid #374151',
        borderRadius: 6,
        padding: '8px 12px'
    },
    arrow: {
        color: '#1f2937',
    },
}))(Tooltip);

function TablePaginationActions(props) {
    const theme = useMuiTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <div style={{ flexShrink: 0, marginLeft: theme.spacing(2.5) }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </div>
    );
}

const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: '#ffffff',
        color: '#1a202c',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
        fontSize: 12,
        border: '1px solid #e5e7eb',
        borderRadius: 6,
        padding: '8px 12px'
    },
    arrow: {
        color: '#ffffff',
    },
}))(Tooltip);

class ProjectList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            project: [],
            count: 0,
            pageStatus: false,
            searchQuery: "",
            suggestions: [],
            // Modal and form states
            openAddModal: false,
            projectForm: {
                project_name: "",
                summary: "",
                priority: "No priority",
                start_date: "",
                target_date: "",
                description: "",
                milestones: [],
                lead_id: "",
                lead_ids: [],
                member_ids: []
            },
            formErrors: {},
            isSubmitting: false,
            showMilestoneForm: false,
            milestoneDraft: { name: "", description: "", dueDate: "" },
            milestoneEditorState: EditorState.createEmpty(),
            allUsers: [],
            isLoadingUsers: false,
            editorState: EditorState.createEmpty(),
            // Popover anchors
            leadAnchorEl: null,
            membersAnchorEl: null,
            priorityAnchorEl: null,
            startAnchorEl: null,
            targetAnchorEl: null,
            // Inline editing popover anchors
            inlinePriorityAnchorEl: null,
            inlineLeadAnchorEl: null,
            inlineMembersAnchorEl: null,
            inlineStartAnchorEl: null,
            inlineTargetAnchorEl: null,
            inlineStatusAnchorEl: null,
            editingProjectId: null,
            // Pending changes for inline editing
            pendingChanges: {
                status: null,
                priority: null,
                lead_ids: [],
                member_ids: [],
                start_date: null,
                target_date: null
            },
            // Cache for single user lookups (id -> user)
            userCache: {},
            tableTh: [
                { id: 'project_name', numeric: false, disablePadding: true, label: 'Name', sortable: true },
                { id: 'priorityDisplay', numeric: false, disablePadding: true, label: 'Priority', sortable: false },
                { id: 'startDisplay', numeric: false, disablePadding: true, label: 'Start date', sortable: true },
                { id: 'leadDisplay', numeric: false, disablePadding: true, label: 'Lead', sortable: false },
                { id: 'membersDisplay', numeric: false, disablePadding: true, label: 'Members', sortable: false },
                { id: 'targetDisplay', numeric: false, disablePadding: true, label: 'Target date', sortable: true },
                { id: 'status', numeric: false, disablePadding: true, label: 'Status', sortable: false },
                { id: 'actions', numeric: false, disablePadding: true, label: 'Actions', sortable: false }
            ],
            page: 0,
            rowsPerPage: 5
        }
        this.projectData = this.projectData.bind(this);
        this.removeProject = this.removeProject.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleStatusChange = this.handleStatusChange.bind(this);
        this.clearSearch = this.clearSearch.bind(this);
        this.handleSuggestionClick = this.handleSuggestionClick.bind(this);
        this.handleOpenAddModal = this.handleOpenAddModal.bind(this);
        this.handleCloseAddModal = this.handleCloseAddModal.bind(this);
        this.handleFormChange = this.handleFormChange.bind(this);
        this.handleSubmitProject = this.handleSubmitProject.bind(this);
        this.handleAddMilestone = this.handleAddMilestone.bind(this);
        this.handleRemoveMilestone = this.handleRemoveMilestone.bind(this);
        this.handleMilestoneDraftChange = this.handleMilestoneDraftChange.bind(this);
        this.handleOpenLeadPopover = this.handleOpenLeadPopover.bind(this);
        this.handleCloseLeadPopover = this.handleCloseLeadPopover.bind(this);
        this.handleOpenMembersPopover = this.handleOpenMembersPopover.bind(this);
        this.handleCloseMembersPopover = this.handleCloseMembersPopover.bind(this);
        this.handleOpenPriorityPopover = this.handleOpenPriorityPopover.bind(this);
        this.handleClosePriorityPopover = this.handleClosePriorityPopover.bind(this);
        this.handleOpenStartPopover = this.handleOpenStartPopover.bind(this);
        this.handleCloseStartPopover = this.handleCloseStartPopover.bind(this);
        this.handleOpenTargetPopover = this.handleOpenTargetPopover.bind(this);
        this.handleCloseTargetPopover = this.handleCloseTargetPopover.bind(this);
        this.getUserById = this.getUserById.bind(this);
        // Inline editing handlers
        this.handleInlinePriorityClick = this.handleInlinePriorityClick.bind(this);
        this.handleInlineLeadClick = this.handleInlineLeadClick.bind(this);
        this.handleInlineMembersClick = this.handleInlineMembersClick.bind(this);
        this.handleInlineTargetClick = this.handleInlineTargetClick.bind(this);
        this.handleInlineStatusClick = this.handleInlineStatusClick.bind(this);
        this.handleCloseInlinePopover = this.handleCloseInlinePopover.bind(this);
        this.handleUpdateProject = this.handleUpdateProject.bind(this);
        this.handlePendingChange = this.handlePendingChange.bind(this);
        this.handleSavePendingChanges = this.handleSavePendingChanges.bind(this);
        this.handleCancelPendingChanges = this.handleCancelPendingChanges.bind(this);
        // permission helpers
        this.getCurrentUserId = this.getCurrentUserId.bind(this);
        this.isUserLead = this.isUserLead.bind(this);
        this.isUserMember = this.isUserMember.bind(this);
        this.canEditAllOverview = this.canEditAllOverview.bind(this);
        this.canEditLimitedOverview = this.canEditLimitedOverview.bind(this);
        this.getRowById = this.getRowById.bind(this);
        this.showNotAllowed = this.showNotAllowed.bind(this);
    }


    isDarkMode() {
        if (this.context && typeof this.context.darkMode !== 'undefined') {
            return this.context.darkMode;
        }
        return localStorage.getItem('theme') === 'dark';
    }

    componentWillMount() {
        if (this.props && this.props.authToken === false) {
            // this.props.history.push('/login');
        }
        this.projectData();
    }

    componentWillReceiveProps(props) {
        if (props && props.authToken === false) {
            // props.history.push('/login');
        }
    }

    projectData = async () => {
        let project = await AuthApi.getProject();

        if (project && project.status === true) {
            this.setState({
                project: project.data,
                count: project.data.length
            });
        }
    }

    // Permission helpers
    getCurrentUserId() {
        try {
            const current = ls.get('user') || {};
            const id = current.id || current._id || current.user_id || current.userId;
            return id != null ? Number(id) : null;
        } catch (_) { return null; }
    }

    getRowById(projectId) {
        return (this.state.project || []).find((p) => Number(p.id) === Number(projectId)) || null;
    }

    isUserLead(row) {
        if (!row) return false;
        const leads = Array.isArray(row.lead_ids) ? row.lead_ids : (row.lead_id ? [row.lead_id] : []);
        const uid = this.getCurrentUserId();
        return uid != null && leads.map(Number).includes(Number(uid));
    }

    isUserMember(row) {
        if (!row) return false;
        const members = Array.isArray(row.member_ids) ? row.member_ids : [];
        const uid = this.getCurrentUserId();
        return uid != null && members.map(Number).includes(Number(uid));
    }

    canEditAllOverview(row) {
        return this.isUserLead(row);
    }

    canEditLimitedOverview(row) {
        // members (or leads) can edit priority and dates
        return this.isUserMember(row) || this.isUserLead(row);
    }

    showNotAllowed() {
        try {
            swal({ title: 'Not allowed', text: 'You are not allowed to perform this action.', icon: 'warning' });
        } catch (_) { /* noop */ }
    }

    // Check if current user is super admin
    isSuperAdmin() {
        let roles = ls.get('roles');
        if (!roles) return false;
        if (typeof roles === 'string') return roles.trim().toLowerCase() === 'super admin';
        if (Array.isArray(roles)) {
            return roles.some(r =>
                (typeof r === 'string' && r.trim().toLowerCase() === 'super admin') ||
                (typeof r === 'object' && (r.name || '').trim().toLowerCase() === 'super admin')
            );
        }
        return false;
    }

    async removeProject(id) {
        const row = this.getRowById(id);
        if (!(this.isUserLead(row) || this.isUserMember(row) || this.isSuperAdmin())) {
            this.showNotAllowed();
            return;
        }
        swal({
            title: "Are you sure?",
            icon: "warning",
            buttons: ["Cancel", "Yes"]
        }).then(async (confirm) => {
            if (confirm) {
                let currentEvent = await AuthApi.deleteProject(id);
                if (currentEvent && currentEvent.status === true) {
                    this.setState({
                        pageStatus: true
                    })
                    this.projectData();
                    setTimeout(
                        () => this.setState({ pageStatus: false }),
                        500
                    );
                    swal({
                        title: "Success!",
                        text: "Project deleted successfully",
                        icon: "success"
                    });
                }
            }
        });
    }

    handleChange(e) {
        const searchQuery = e.target.value;
        const suggestions = this.state.project.filter((item) => {
            return (
                item.project_name.toLowerCase().includes(searchQuery.toLowerCase())
            );
        });
        this.setState({ searchQuery, suggestions });
    }

    handleSearch = () => {
        // Trigger search functionality
        const filterUser = this.state.project.filter((item) => {
            return (
                item.project_name.toLowerCase().includes(this.state.searchQuery.toLowerCase())
            );
        });
        this.setState({ filterUser });
    };

    clearSearch = () => {
        this.setState({ searchQuery: "", suggestions: [] }, this.handleSearch);
    };

    handleSuggestionClick = (suggestion) => {
        this.setState({ searchQuery: suggestion.project_name, suggestions: [] }, this.handleSearch);
    };

    handleStatusChange = async (id, currentStatus) => {
        const row = this.getRowById(id);
        if (!this.canEditAllOverview(row)) { this.showNotAllowed(); return; }
        try {
            const newStatus = currentStatus === 1 ? 0 : 1;
            const response = await AuthApi.Projectstatusupdate(id, newStatus);

            if (response && response.status === true) {
                this.setState({ pageStatus: true });
                await this.projectData();
                setTimeout(() => this.setState({ pageStatus: false }), 500);
                swal({
                    title: "Success!",
                    text: "Project status updated successfully",
                    icon: "success",
                });
            } else {
                swal({
                    title: "Error!",
                    text: "Failed to update project status",
                    icon: "error",
                });
            }
        } catch (error) {
            console.error("Error updating status:", error);
            swal({
                title: "Error!",
                text: "Failed to update project status",
                icon: "error",
            });
        }
    };

    // Modal handlers
    handleOpenAddModal = async () => {
        this.setState({ openAddModal: true });
        await this.fetchUsers();
    };

    handleCloseAddModal = () => {
        this.setState({
            openAddModal: false,
            projectForm: {
                project_name: "",
                summary: "",
                priority: "No priority",
                start_date: "",
                target_date: "",
                description: "",
                milestones: [],
                lead_id: "",
                lead_ids: [],
                member_ids: []
            },
            formErrors: {},
            isSubmitting: false,
            showMilestoneForm: false,
            milestoneDraft: { name: "", description: "", dueDate: "" },
            editorState: EditorState.createEmpty(),
            milestoneEditorState: EditorState.createEmpty()
        });
    };

    handleFormChange = (e) => {
        const { name, value } = e.target;
        this.setState({
            projectForm: { ...this.state.projectForm, [name]: value }
        });
    };

    handleMilestoneDraftChange = (e) => {
        const { name, value } = e.target;
        this.setState({
            milestoneDraft: { ...this.state.milestoneDraft, [name]: value }
        });
    };

    handleAddMilestone = () => {
        if (!this.state.milestoneDraft.name) {
            return;
        }
        const updated = [
            ...this.state.projectForm.milestones,
            {
                name: this.state.milestoneDraft.name,
                // Save milestone description as DraftJS JSON (rich text)
                description: JSON.stringify(convertToRaw(this.state.milestoneEditorState.getCurrentContent())),
                dueDate: this.state.milestoneDraft.dueDate
            }
        ];
        this.setState({
            projectForm: { ...this.state.projectForm, milestones: updated },
            milestoneDraft: { name: "", description: "", dueDate: "" },
            milestoneEditorState: EditorState.createEmpty(),
            showMilestoneForm: false
        });
    };

    // Lead popover handlers
    handleOpenLeadPopover = (event) => {
        this.setState({ leadAnchorEl: event.currentTarget });
        if (this.state.allUsers.length === 0) {
            this.fetchUsers();
        }
    };

    handleCloseLeadPopover = () => {
        this.setState({ leadAnchorEl: null });
    };

    // Members popover handlers
    handleOpenMembersPopover = (event) => {
        this.setState({ membersAnchorEl: event.currentTarget });
        if (this.state.allUsers.length === 0) {
            this.fetchUsers();
        }
    };

    handleCloseMembersPopover = () => {
        this.setState({ membersAnchorEl: null });
    };

    // Priority popover
    handleOpenPriorityPopover = (event) => {
        this.setState({ priorityAnchorEl: event.currentTarget });
    };
    handleClosePriorityPopover = () => {
        this.setState({ priorityAnchorEl: null });
    };

    // Start date popover
    handleOpenStartPopover = (event) => {
        this.setState({ startAnchorEl: event.currentTarget });
    };
    handleCloseStartPopover = () => {
        this.setState({ startAnchorEl: null });
    };

    // Target date popover
    handleOpenTargetPopover = (event) => {
        this.setState({ targetAnchorEl: event.currentTarget });
    };
    handleCloseTargetPopover = () => {
        this.setState({ targetAnchorEl: null });
    };

    // Inline editing handlers
    handleInlinePriorityClick = (event, projectId) => {
        const project = this.state.project.find(p => p.id === projectId);
        if (!(this.canEditAllOverview(project) || this.canEditLimitedOverview(project))) { this.showNotAllowed(); return; }
        // Handle both lead_id (single) and lead_ids (array) from existing data
        let existingLeadIds = [];
        if (project?.lead_ids && Array.isArray(project.lead_ids)) {
            existingLeadIds = project.lead_ids;
        } else if (project?.lead_id) {
            existingLeadIds = [project.lead_id];
        }

        this.setState({
            inlinePriorityAnchorEl: event.currentTarget,
            editingProjectId: projectId,
            pendingChanges: {
                priority: project?.priority || null,
                lead_ids: existingLeadIds,
                member_ids: project?.member_ids || [],
                target_date: project?.target_date || null
            }
        });
    };

    handleInlineLeadClick = (event, projectId) => {
        const project = this.state.project.find(p => p.id === projectId);
        if (!this.canEditAllOverview(project)) { this.showNotAllowed(); return; }
        // Handle both lead_id (single) and lead_ids (array) from existing data
        let existingLeadIds = [];
        if (project?.lead_ids && Array.isArray(project.lead_ids)) {
            existingLeadIds = project.lead_ids;
        } else if (project?.lead_id) {
            existingLeadIds = [project.lead_id];
        }
        console.log('Initializing lead selection:', { project, existingLeadIds });

        this.setState({
            inlineLeadAnchorEl: event.currentTarget,
            editingProjectId: projectId,
            pendingChanges: {
                priority: project?.priority || null,
                lead_ids: existingLeadIds,
                member_ids: project?.member_ids || [],
                target_date: project?.target_date || null
            }
        });
        if (this.state.allUsers.length === 0) {
            this.fetchUsers();
        }
    };

    handleInlineMembersClick = (event, projectId) => {
        const project = this.state.project.find(p => p.id === projectId);
        if (!this.canEditAllOverview(project)) { this.showNotAllowed(); return; }
        // Handle both lead_id (single) and lead_ids (array) from existing data
        let existingLeadIds = [];
        if (project?.lead_ids && Array.isArray(project.lead_ids)) {
            existingLeadIds = project.lead_ids;
        } else if (project?.lead_id) {
            existingLeadIds = [project.lead_id];
        }

        this.setState({
            inlineMembersAnchorEl: event.currentTarget,
            editingProjectId: projectId,
            pendingChanges: {
                priority: project?.priority || null,
                lead_ids: existingLeadIds,
                member_ids: project?.member_ids || [],
                target_date: project?.target_date || null
            }
        });
        if (this.state.allUsers.length === 0) {
            this.fetchUsers();
        }
    };

    handleInlineTargetClick = (event, projectId) => {
        const project = this.state.project.find(p => p.id === projectId);
        if (!(this.canEditAllOverview(project) || this.canEditLimitedOverview(project))) { this.showNotAllowed(); return; }
        // Handle both lead_id (single) and lead_ids (array) from existing data
        let existingLeadIds = [];
        if (project?.lead_ids && Array.isArray(project.lead_ids)) {
            existingLeadIds = project.lead_ids;
        } else if (project?.lead_id) {
            existingLeadIds = [project.lead_id];
        }

        this.setState({
            inlineTargetAnchorEl: event.currentTarget,
            editingProjectId: projectId,
            pendingChanges: {
                priority: project?.priority || null,
                lead_ids: existingLeadIds,
                member_ids: project?.member_ids || [],
                target_date: project?.target_date || null
            }
        });
    };

    handleCloseInlinePopover = () => {
        this.setState({
            inlinePriorityAnchorEl: null,
            inlineLeadAnchorEl: null,
            inlineMembersAnchorEl: null,
            inlineTargetAnchorEl: null,
            inlineStatusAnchorEl: null,
            editingProjectId: null,
            pendingChanges: {
                status: null,
                priority: null,
                lead_ids: [],
                member_ids: [],
                target_date: null
            }
        });
    };

    handlePendingChange = (field, value) => {
        this.setState({
            pendingChanges: {
                ...this.state.pendingChanges,
                [field]: value
            }
        });
    };

    handleSavePendingChanges = async () => {
        if (!this.state.editingProjectId) return;

        try {
            const project = this.state.project.find(p => p.id === this.state.editingProjectId);
            if (!project) return;

            const updatedProject = {
                ...project,
                status: this.state.pendingChanges.status ?? project.status,
                priority: this.state.pendingChanges.priority,
                lead_id: this.state.pendingChanges.lead_ids.length > 0 ? this.state.pendingChanges.lead_ids[0] : null, // Keep lead_id for backward compatibility
                lead_ids: this.state.pendingChanges.lead_ids,
                member_ids: this.state.pendingChanges.member_ids,
                target_date: this.state.pendingChanges.target_date
            };

            // Avoid sending milestones for inline updates to prevent backend replacement
            const payload = { ...updatedProject };
            if (Object.prototype.hasOwnProperty.call(payload, 'milestones')) {
                delete payload.milestones;
            }
            const response = await AuthApi.editProject(payload, this.state.editingProjectId);

            if (response && response.status === true) {
                this.setState({ pageStatus: true });
                await this.projectData();
                setTimeout(() => this.setState({ pageStatus: false }), 500);
                this.handleCloseInlinePopover();
                swal({
                    title: "Success!",
                    text: "Project updated successfully",
                    icon: "success",
                });
            } else {
                swal({
                    title: "Error!",
                    text: "Failed to update project",
                    icon: "error",
                });
            }
        } catch (error) {
            console.error("Error updating project:", error);
            swal({
                title: "Error!",
                text: "Failed to update project",
                icon: "error",
            });
        }
    };

    handleCancelPendingChanges = () => {
        this.handleCloseInlinePopover();
    };

    handleUpdateProject = async (field, value) => {
        if (!this.state.editingProjectId) return;

        try {
            const project = this.state.project.find(p => p.id === this.state.editingProjectId);
            if (!project) return;

            const updatedProject = { ...project };
            updatedProject[field] = value;

            // Avoid sending milestones for single-field inline update
            const payload = { ...updatedProject };
            if (Object.prototype.hasOwnProperty.call(payload, 'milestones')) {
                delete payload.milestones;
            }
            const response = await AuthApi.editProject(payload, this.state.editingProjectId);

            if (response && response.status === true) {
                this.setState({ pageStatus: true });
                await this.projectData();
                setTimeout(() => this.setState({ pageStatus: false }), 500);
                this.handleCloseInlinePopover();
                swal({
                    title: "Success!",
                    text: "Project updated successfully",
                    icon: "success",
                });
            } else {
                swal({
                    title: "Error!",
                    text: "Failed to update project",
                    icon: "error",
                });
            }
        } catch (error) {
            console.error("Error updating project:", error);
            swal({
                title: "Error!",
                text: "Failed to update project",
                icon: "error",
            });
        }
    };

    handleInlineStatusClick = (event, projectId) => {
        const project = this.state.project.find(p => p.id === projectId);
        if (!this.canEditAllOverview(project)) { this.showNotAllowed(); return; }
        this.setState({
            inlineStatusAnchorEl: event.currentTarget,
            editingProjectId: projectId,
            pendingChanges: {
                status: project?.status || 'Backlog',
                priority: project?.priority || null,
                lead_ids: Array.isArray(project?.lead_ids) ? project.lead_ids : (project?.lead_id ? [project.lead_id] : []),
                member_ids: project?.member_ids || [],
                target_date: project?.target_date || null
            }
        });
    };

    async getUserById(id) {
        const key = String(id);
        if (!id) return null;
        if (this.state.userCache[key]) return this.state.userCache[key];
        try {
            const res = await AuthApi.singleUser(id);
            const user = res && res.data ? res.data : null;
            if (user) {
                this.setState(prev => ({ userCache: { ...prev.userCache, [key]: user } }));
                return user;
            }
        } catch (e) { }
        return null;
    }

    handleRemoveMilestone = (index) => {
        const updated = this.state.projectForm.milestones.filter((_, i) => i !== index);
        this.setState({
            projectForm: { ...this.state.projectForm, milestones: updated }
        });
    };

    handleEditorChange = (state) => {
        this.setState({ editorState: state });
        this.setState({
            projectForm: {
                ...this.state.projectForm,
                description: state.getCurrentContent().getPlainText()
            }
        });
    };

    handleKeyCommand = (command, state) => {
        const newState = RichUtils.handleKeyCommand(state, command);
        if (newState) {
            this.handleEditorChange(newState);
            return 'handled';
        }
        return 'not-handled';
    };

    uploadImageCallBack = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new window.FileReader();
            reader.onloadend = () => {
                resolve({ data: { link: reader.result } });
            };
            reader.readAsDataURL(file);
        });
    };

    fetchUsers = async () => {
        try {
            this.setState({ isLoadingUsers: true });
            const response = await AuthApi.getData();

            let list = [];
            if (response && response.status === true && Array.isArray(response.data)) {
                list = response.data;
            } else if (Array.isArray(response)) {
                list = response;
            } else if (response && Array.isArray(response.data)) {
                list = response.data;
            }

            const filtered = list.filter((u) => {
                return u?.user_logged === 1;
            });

            if (filtered.length === 0 && list.length > 0) {
                this.setState({ allUsers: list });
            } else {
                this.setState({ allUsers: filtered });
            }
        } catch (e) {
            console.error("Error fetching users:", e);
            this.setState({ allUsers: [] });
        } finally {
            this.setState({ isLoadingUsers: false });
        }
    };

    validate = (values) => {
        let errors = {};
        if (!values.project_name) {
            errors.project_name = "Cannot be blank";
        }
        return errors;
    };

    handleSubmitProject = async (e) => {
        e.preventDefault();
        const errors = this.validate(this.state.projectForm);
        this.setState({ formErrors: errors, isSubmitting: true });

        if (Object.keys(errors).length === 0) {
            try {
                swal({
                    title: "Loading",
                    text: "Please wait...",
                    buttons: false,
                    closeOnClickOutside: false,
                    closeOnEsc: false,
                    width: "10%",
                    content: {
                        element: "img",
                        attributes: {
                            src: "https://www.boasnotas.com/img/loading2.gif",
                            style: "width: 50px;"
                        }
                    }
                });

                // Normalize payload to match backend
                const form = this.state.projectForm;
                const payload = {
                    project_name: form.project_name?.trim() || "",
                    summary: form.summary || null,
                    priority: form.priority || "No priority",
                    start_date: form.start_date || null,
                    target_date: form.target_date || null,
                    description: JSON.stringify(convertToRaw(this.state.editorState.getCurrentContent())),
                    lead_id: form.lead_id || null, // Keep for backward compatibility
                    lead_ids: Array.isArray(form.lead_ids)
                        ? form.lead_ids.map((id) => Number(id)).filter((id) => !isNaN(id))
                        : [],
                    member_ids: Array.isArray(form.member_ids)
                        ? form.member_ids.map((id) => Number(id)).filter((id) => !isNaN(id))
                        : [],
                    milestones: Array.isArray(form.milestones)
                        ? form.milestones.map((m) => ({
                            name: m?.name || "",
                            description: m?.description || null,
                            dueDate: m?.dueDate || null,
                        }))
                        : [],
                };

                const create = await AuthApi.createProject(payload);
                swal.close();

                if (create && create.status === true) {
                    this.handleCloseAddModal();
                    this.projectData();
                    swal({
                        title: "Success!",
                        text: "Project created successfully",
                        icon: "success",
                    });
                } else {
                    swal({
                        title: "OOPS!",
                        icon: "error",
                        text: create.message || "Something went wrong, Please try later!"
                    });
                }
            } catch (error) {
                swal.close();
                console.error("Error creating project:", error);
                swal({
                    title: "Error",
                    icon: "error",
                    text: "An error occurred while creating the project. Please try again later."
                });
            }
        }
        this.setState({ isSubmitting: false });
    };

    handleChangePage = (event, newPage) => {
        this.setState({ page: newPage });
    };

    handleChangeRowsPerPage = (event) => {
        this.setState({ rowsPerPage: parseInt(event.target.value, 10), page: 0 });
    };

    render() {
        const classes = this.props;
        const filterUser = this.state.filterUser || this.state.project;
        const { page, rowsPerPage } = this.state;
        const paginatedRows = (filterUser || []).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
        const isSuperAdmin = this.isSuperAdmin();

        // Cell render helpers
        this.renderPriorityBadge = (priority, projectId, darkMode) => {
            const row = this.getRowById(projectId);
            const allowed = this.canEditAllOverview(row) || this.canEditLimitedOverview(row);
            const map = {
                'High': { bg: '#ef4444', label: '!' },
                'Medium': { bg: '#f59e0b', label: '!' },
                'Low': { bg: '#22c55e', label: '!' },
                'No priority': { bg: '#94a3b8', label: '!' },
            };
            const p = map[priority] || map['No priority'];
            return (
                <Tooltip title={`Click to change priority: ${priority || 'No priority'}`}>
                    <div
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            cursor: allowed ? 'pointer' : 'default',
                            padding: '4px',
                            borderRadius: '4px',
                            transition: 'background-color 0.2s'
                        }}
                        onClick={(e) => allowed ? this.handleInlinePriorityClick(e, projectId) : this.showNotAllowed()}
                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = darkMode ? '#333' : '#f0f0f0'}
                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                    >
                        <div style={{ width: 16, height: 16, borderRadius: 4, backgroundColor: p.bg, color: '#000', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 10 }}>!</div>
                    </div>
                </Tooltip>
            );
        };

        this.renderLeadAvatar = (leadIds, projectId, darkMode) => {
            const row = this.getRowById(projectId);
            const allowed = this.canEditAllOverview(row);
            const ids = Array.isArray(leadIds) ? leadIds.map(Number) : (leadIds ? [Number(leadIds)] : []);

            const TooltipComponent = darkMode ? DarkTooltip : LightTooltip;

            if (ids.length === 0) return (
                <TooltipComponent title="Click to assign leads">
                    <div
                        style={{
                            width: 28,
                            height: 28,
                            borderRadius: '50%',
                            overflow: 'hidden',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: darkMode ? '#374151' : '#e2e8f0',
                            color: darkMode ? '#9ca3af' : '#64748b',
                            fontSize: 12,
                            cursor: allowed ? 'pointer' : 'default',
                            border: `2px dashed ${darkMode ? '#4b5563' : '#cbd5e0'}`,
                            transition: 'all 0.2s'
                        }}
                        onClick={(e) => allowed ? this.handleInlineLeadClick(e, projectId) : this.showNotAllowed()}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = darkMode ? '#4b5563' : '#cbd5e0';
                            e.currentTarget.style.borderColor = darkMode ? '#6b7280' : '#94a3b8';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = darkMode ? '#374151' : '#e2e8f0';
                            e.currentTarget.style.borderColor = darkMode ? '#4b5563' : '#cbd5e0';
                        }}
                    >
                        +
                    </div>
                </TooltipComponent>
            );

            const users = ids.map(id => this.state.userCache[String(id)] || null);
            // Fetch any missing
            ids.forEach((id) => { if (!this.state.userCache[String(id)]) this.getUserById(id); });

            const avatars = users.slice(0, 2).map((u, idx) => {
                const initials = ((u?.firstName?.[0] || u?.name?.[0] || 'U') + (u?.lastName?.[0] || '')).toUpperCase();
                const photo = u?.photo;
                return (
                    <div key={idx} style={{ width: 22, height: 22, borderRadius: '50%', overflow: 'hidden', border: '2px solid #ec4899', marginLeft: idx === 0 ? 0 : -8, backgroundColor: '#ec4899', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 10 }}>
                        {photo ? <img src={photo} alt={initials} style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : initials}
                    </div>
                );
            });

            const remaining = ids.length - avatars.length;
            const names = ids
                .map(id => this.state.userCache[String(id)])
                .filter(Boolean)
                .map(u => (u.firstName ? `${u.firstName} ${u.lastName || ''}`.trim() : (u.name || u.email || `User ${u.id}`)))
                .join(', ');
            const tooltipText = names || `${ids.length} lead${ids.length === 1 ? '' : 's'}`;

            return (
                <TooltipComponent title={`Click to change leads: ${tooltipText}`}>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            cursor: allowed ? 'pointer' : 'default',
                            padding: '4px',
                            borderRadius: '4px',
                            transition: 'background-color 0.2s'
                        }}
                        onClick={(e) => allowed ? this.handleInlineLeadClick(e, projectId) : this.showNotAllowed()}
                        // onMouseEnter={(e) => e.currentTarget.style.backgroundColor = darkMode ? '#333' : '#f0f0f0'}
                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                    >
                        {avatars}
                        {remaining > 0 && (
                            <div style={{ marginLeft: 6, fontSize: 12, color: darkMode ? '#9ca3af' : '#64748b' }}>+{remaining}</div>
                        )}
                    </div>
                </TooltipComponent>
            );
        };

        this.renderMembersGroup = (memberIds, projectId, darkMode) => {
            const row = this.getRowById(projectId);
            const allowed = this.canEditAllOverview(row);
            const ids = Array.isArray(memberIds) ? memberIds.map(Number) : [];
            const users = ids.map(id => this.state.userCache[String(id)] || null);
            // Fetch any missing
            ids.forEach((id) => { if (!this.state.userCache[String(id)]) this.getUserById(id); });
            const avatars = users.slice(0, 3).map((u, idx) => {
                const initials = ((u?.firstName?.[0] || u?.name?.[0] || 'U') + (u?.lastName?.[0] || '')).toUpperCase();
                const photo = u?.photo;
                return (
                    <div key={idx} style={{ width: 22, height: 22, borderRadius: '50%', overflow: 'hidden', border: '2px solid #2d3748', marginLeft: idx === 0 ? 0 : -8, backgroundColor: '#6b7280', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 10 }}>
                        {photo ? <img src={photo} alt={initials} style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : initials}
                    </div>
                );
            });
            const remaining = ids.length - avatars.length;
            const names = ids
                .map(id => this.state.userCache[String(id)])
                .filter(Boolean)
                .map(u => (u.firstName ? `${u.firstName} ${u.lastName || ''}`.trim() : (u.name || u.email || `User ${u.id}`)))
                .join(', ');
            const tooltipText = names || `${ids.length} member${ids.length === 1 ? '' : 's'}`;
            return (
                <Tooltip title={`Click to change members: ${tooltipText}`}>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            cursor: allowed ? 'pointer' : 'default',
                            padding: '4px',
                            borderRadius: '4px',
                            transition: 'background-color 0.2s'
                        }}
                        onClick={(e) => allowed ? this.handleInlineMembersClick(e, projectId) : this.showNotAllowed()}
                        // onMouseEnter={(e) => e.currentTarget.style.backgroundColor = darkMode ? '#333' : '#f0f0f0'}
                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                    >
                        {avatars}
                        {remaining > 0 && (
                            <div style={{ marginLeft: 6, fontSize: 12, color: '#cbd5e0' }}>+{remaining}</div>
                        )}
                    </div>
                </Tooltip>
            );
        };

        this.renderTargetDate = (dateStr, projectId, darkMode) => {
            const row = this.getRowById(projectId);
            const allowed = this.canEditAllOverview(row) || this.canEditLimitedOverview(row);
            if (!dateStr) return (
                <Tooltip title="Click to set target date">
                    <div
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: 6,
                            cursor: allowed ? 'pointer' : 'default',
                            padding: '6px 10px',
                            borderRadius: 8,
                            color: '#ffffff',
                            background: '#e34d4d',
                            border: '1px solid #e34d4d',
                            width: '110px'
                        }}
                        onClick={(e) => allowed ? this.handleInlineTargetClick(e, projectId) : this.showNotAllowed()}
                    >
                        <span style={{ fontWeight: 700 }}>Set date</span>
                    </div>
                </Tooltip>
            );

            // Format date to dd-mm-yyyy
            const formatDate = (dateString) => {
                try {
                    const date = new Date(dateString);
                    if (isNaN(date)) return dateString;
                    const day = String(date.getDate()).padStart(2, '0');
                    const month = String(date.getMonth() + 1).padStart(2, '0');
                    const year = date.getFullYear();
                    return `${day}-${month}-${year}`;
                } catch (error) {
                    return dateString;
                }
            };

            return (
                <Tooltip title="Click to change target date">
                    <div
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: 6,
                            cursor: allowed ? 'pointer' : 'default',
                            padding: '6px 10px',
                            borderRadius: 8,
                            color: '#ffffff',
                            background: '#ec8f8fff',
                            // border: '1px solid #ec8f8fff',
                            width: '110px'
                        }}
                        onClick={(e) => allowed ? this.handleInlineTargetClick(e, projectId) : this.showNotAllowed()}
                    >
                        <span style={{ fontWeight: 700 }}>{formatDate(dateStr)}</span>
                    </div>
                </Tooltip>
            );
        };
        const renderStatus = (row) => {
            const status = row.status || 'Backlog';
            const styles = { background: '#64748b', color: '#fff', width: '110px', justifyContent: 'center' };
            if (status === 'Backlog') styles.background = '#475569';
            if (status === 'Planned') styles.background = '#eab308';
            if (status === 'In Progress') styles.background = '#2563eb';
            if (status === 'Completed') styles.background = '#16a34a';
            if (status === 'Canceled') styles.background = '#6b7280';
            const allowed = this.canEditAllOverview(row);
            return (
                <Tooltip title={`Status: ${status}`}>
                    <Chip
                        label={status}
                        size="small"
                        className="status-chip"
                        data-status={status}
                        style={{ ...styles, cursor: allowed ? 'pointer' : 'default', borderRadius: '6px' }}
                        onClick={(e) => allowed ? this.handleInlineStatusClick(e, row.id) : this.showNotAllowed()}
                    />
                </Tooltip>
            );
        };
        return (
            <div>
                <AuthCheckComponent authToken={this.props.authToken} />
                <Header
                    {...this.props}
                    authUser={this.props.authUser}
                    setAutUser={this.props.setAutUser}
                    component={
                        <div style={{ marginBottom: "11%" }}>
                            <Card className={classes.root} style={{ marginBottom: '3%' }}>
                                <CardContent>
                                    <Breadcrumb
                                        {...this.props}
                                        primaryPageName="Project"
                                        primaryPageLink="/project"
                                        isSecondaryPage={false}
                                        secondaryPageName="" />
                                </CardContent>
                            </Card>
                            {/* Header bar with Search and Add button */}
                            <ThemeContext.Consumer>
                                {({ darkMode }) => (
                                    <div className="project-header-bar" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                                        <Typography
                                            variant="h2"
                                            className="project-title"
                                            style={{ margin: 0, color: darkMode ? '#FFFFFF' : '#1B6E95' }}
                                        >
                                            Project
                                        </Typography>

                                        <div style={{ display: 'flex', gap: 12, alignItems: 'center', marginRight: '30px' }}>
                                            <div style={{ position: 'relative' }}>
                                                <TextField
                                                    label="Search"
                                                    value={this.state.searchQuery}
                                                    onChange={this.handleChange}
                                                    variant="outlined"
                                                    className="project-search-textfield"
                                                    InputLabelProps={{
                                                        shrink: this.state.searchQuery !== "",
                                                        style: {
                                                            color: '#1b6e95',
                                                            transform: this.state.searchQuery !== "" ? 'translate(14px, -6px) scale(0.75)' : 'translate(14px, 11px) scale(1)',
                                                            transition: 'transform 0.2s ease-in-out'
                                                        }
                                                    }}
                                                    InputProps={{
                                                        style: {
                                                            backgroundColor: 'lightgray',
                                                            borderRadius: '25px',
                                                            height: "40px",
                                                            color: '#1a202c'
                                                        },
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                {this.state.searchQuery && (
                                                                    <ClearIcon onClick={this.clearSearch} style={{ cursor: 'pointer' }} />
                                                                )}
                                                                <SearchIcon onClick={this.handleSearch} style={{ cursor: 'pointer' }} />
                                                            </InputAdornment>
                                                        )
                                                    }}
                                                />
                                                {this.state.searchQuery && this.state.suggestions.length > 0 && (
                                                    <Paper
                                                        style={{
                                                            position: 'absolute',
                                                            top: '100%',
                                                            left: 0,
                                                            right: 0,
                                                            marginTop: 4,
                                                            zIndex: 10,
                                                            maxHeight: '200px',
                                                            overflowY: 'auto',
                                                            border: '1px solid #ccc',
                                                            borderRadius: '4px',
                                                            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                                                            backgroundColor: darkMode ? '#1e1e1e' : '#ffffff',
                                                            color: darkMode ? '#ffffff' : '#1a202c'
                                                        }}>
                                                        {this.state.suggestions.map((suggestion, index) => (
                                                            <MenuItem
                                                                key={index}
                                                                onClick={() => this.handleSuggestionClick(suggestion)}
                                                                style={{
                                                                    padding: '8px 16px',
                                                                    cursor: 'pointer',
                                                                    color: darkMode ? '#ffffff' : '#1a202c',
                                                                    fontSize: '0.9rem'
                                                                }}
                                                            >
                                                                {suggestion.project_name}
                                                            </MenuItem>
                                                        ))}
                                                    </Paper>
                                                )}
                                            </div>
                                            <Button variant="contained" style={{ backgroundColor: '#1B6E95', color: '#fff', textTransform: 'capitalize' }} onClick={this.handleOpenAddModal}>Add project</Button>
                                        </div>
                                    </div>
                                )}
                            </ThemeContext.Consumer>

                            {/* List-style view */}
                            <ThemeContext.Consumer>
                                {({ darkMode }) => (
                                    <div>
                                        <div style={{ border: `1px solid ${darkMode ? '#374151' : '#e2e8f0'}`, borderRadius: 6, overflow: 'hidden', width: '98%', margin: '0 auto' }}>
                                            <div style={{ overflowX: 'auto', width: '100%' }}>
                                                <table style={{ width: '100%', minWidth: '900px', borderCollapse: 'collapse' }}>
                                                    <thead>
                                                        <tr style={{ background: '#1b6e95', color: '#fff', fontWeight: 600 }}>
                                                            <th style={{ padding: '8px 8px', verticalAlign: 'middle', height: 56 }}>Name</th>
                                                            <th style={{ padding: '8px 8px', verticalAlign: 'middle', height: 56 }}>Priority</th>
                                                            <th style={{ padding: '8px 8px', textAlign: 'left', verticalAlign: 'middle', height: 56 }}>Lead</th>
                                                            <th style={{ padding: '8px 8px', textAlign: 'left', verticalAlign: 'middle', height: 56 }}>Members</th>
                                                            <th style={{ padding: '8px 8px', verticalAlign: 'middle', height: 56 }}>Target date</th>
                                                            <th style={{ padding: '8px 8px', verticalAlign: 'middle', height: 56 }}>Status</th>
                                                            {isSuperAdmin && (
                                                                <th style={{ padding: '8px 8px', textAlign: 'center', verticalAlign: 'middle', height: 56 }}>Actions</th>
                                                            )}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {paginatedRows.length === 0 ? (
                                                            <tr style={{ borderTop: `1px solid ${darkMode ? '#4b5563' : '#e2e8f0'}`, background: darkMode ? '#000000' : '#fff', minHeight: 56, height: 56 }}>
                                                                <td colSpan={isSuperAdmin ? 7 : 6} style={{ padding: '8px 8px', textAlign: 'center', verticalAlign: 'middle', height: 56, color: darkMode ? '#ffffff' : 'inherit' }}>
                                                                    No rows found
                                                                </td>
                                                            </tr>
                                                        ) : (
                                                            paginatedRows.map((row, idx) => (
                                                                <tr key={row.id || idx} style={{ borderTop: `1px solid ${darkMode ? '#4b5563' : '#e2e8f0'}`, background: darkMode ? '#000000' : '#fff', minHeight: 56, height: 56 }}>
                                                                    <td style={{ padding: '8px 8px', fontWeight: 600, cursor: 'pointer', color: darkMode ? '#ffffff' : '#1B6E95', verticalAlign: 'middle', height: 56 }} onClick={() => this.props.history.push(`/project/${row.id}`)}>
                                                                        {row.project_name}
                                                                    </td>
                                                                    <td style={{ padding: '8px 8px', verticalAlign: 'middle', height: 56, color: darkMode ? '#ffffff' : 'inherit' }}>{this.renderPriorityBadge(row.priority, row.id, darkMode)}</td>
                                                                    <td style={{ padding: '8px 8px', verticalAlign: 'middle', height: 56, color: darkMode ? '#ffffff' : 'inherit' }}>{this.renderLeadAvatar(row.lead_ids || row.lead_id, row.id, darkMode)}</td>
                                                                    <td style={{ padding: '8px 8px', verticalAlign: 'middle', height: 56, color: darkMode ? '#ffffff' : 'inherit' }}>{this.renderMembersGroup(row.member_ids, row.id, darkMode)}</td>
                                                                    <td style={{ padding: '8px 8px', verticalAlign: 'middle', height: 56, color: darkMode ? '#ffffff' : 'inherit' }}>{this.renderTargetDate(row.target_date, row.id, darkMode)}</td>
                                                                    <td style={{ padding: '8px 8px', verticalAlign: 'middle', height: 56, color: darkMode ? '#ffffff' : 'inherit' }}>{renderStatus(row)}</td>
                                                                    {isSuperAdmin && (
                                                                        <td style={{ padding: '8px 8px', textAlign: 'center', verticalAlign: 'middle', height: 56, color: darkMode ? '#ffffff' : 'inherit' }}>
                                                                            <Button
                                                                                variant="contained"
                                                                                color="secondary"
                                                                                size="small"
                                                                                style={{ backgroundColor: '#e53935', color: '#fff', minWidth: 0, width: 32, height: 32, borderRadius: '10%' }}
                                                                                onClick={() => this.removeProject(row.id)}
                                                                                title={'Delete project'}
                                                                            >
                                                                                <DeleteOutlinedIcon fontSize="small" />
                                                                            </Button>
                                                                        </td>
                                                                    )}
                                                                </tr>
                                                            ))
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                            <TablePagination
                                                component="div"
                                                count={(filterUser || []).length}
                                                page={this.state.page}
                                                onPageChange={this.handleChangePage}
                                                rowsPerPage={this.state.rowsPerPage}
                                                onRowsPerPageChange={this.handleChangeRowsPerPage}
                                                rowsPerPageOptions={[5, 10, 25, 50]}
                                                style={{ color: darkMode ? '#ffffff' : 'inherit', borderBottom: 'none', width: 'fit-content' }}
                                                ActionsComponent={TablePaginationActions}
                                            />
                                        </div>
                                    </div>
                                )}
                            </ThemeContext.Consumer>
                        </div>
                    } />
                <Footer {...this.props} />

                {/* Add Project Modal */}
                <ThemeContext.Consumer>
                    {({ darkMode }) => (
                        <Dialog
                            open={this.state.openAddModal}
                            onClose={this.handleCloseAddModal}
                            maxWidth="md"
                            fullWidth
                            PaperProps={{
                                style: {
                                    backgroundColor: darkMode ? '#1e1e1e' : '#ffffff',
                                    color: darkMode ? '#ffffff' : '#1a202c',
                                    borderRadius: '8px',
                                    boxShadow: '0 8px 24px rgba(0,0,0,0.2)'
                                }
                            }}
                        >
                            <style>{`
                        .MuiDialogTitle-root h2 span,
                        .MuiDialogTitle-root h6 span {
                            background: transparent !important;
                            padding: 0 !important;
                        }
                    `}</style>
                            <DialogTitle style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                backgroundColor: '#1B6E95',
                                color: '#ffffff',
                                padding: '12px 16px',
                                position: 'relative',
                                borderTopLeftRadius: 8,
                                borderTopRightRadius: 8
                            }}>
                                <Typography variant="h6" style={{ color: '#ffffff', fontWeight: 600 }}>
                                    New project
                                </Typography>
                                <IconButton
                                    aria-label="Close"
                                    onClick={this.handleCloseAddModal}
                                    size="small"
                                    disableRipple
                                    disableFocusRipple
                                    style={{
                                        position: 'absolute',
                                        top: 10,
                                        right: 16,
                                        width: 32,
                                        height: 32,
                                        padding: 0,
                                        backgroundColor: '#e53935',
                                        color: '#fff',
                                        borderRadius: '50%',
                                        outline: 'none',
                                        boxShadow: '0 2px 6px rgba(0,0,0,0.35)',
                                        zIndex: 3
                                    }}
                                    onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#e53935'; }}
                                    onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#e53935'; }}
                                >
                                    <CloseIcon fontSize="small" />
                                </IconButton>
                            </DialogTitle>

                            <DialogContent style={{ padding: '24px' }}>
                                <form onSubmit={this.handleSubmitProject}>
                                    {/* Project Name and Summary */}
                                    <TextField
                                        fullWidth
                                        name="project_name"
                                        label="Project name"
                                        variant="outlined"
                                        error={this.state.formErrors.project_name && true}
                                        value={this.state.projectForm.project_name}
                                        onChange={this.handleFormChange}
                                        style={{ marginBottom: '12px' }}
                                        InputProps={{
                                            style: {
                                                backgroundColor: darkMode ? '#2a2a2a' : '#ffffff',
                                                color: darkMode ? '#ffffff' : '#1a202c',
                                                borderRadius: '8px'
                                            }
                                        }}
                                        inputProps={{
                                            style: { color: darkMode ? '#ffffff' : '#1a202c' }
                                        }}
                                        InputLabelProps={{
                                            style: { color: darkMode ? '#cccccc' : '#4a5568' }
                                        }}
                                    />
                                    {this.state.formErrors.project_name && (
                                        <Typography color="error" style={{ marginBottom: '12px' }}>
                                            {this.state.formErrors.project_name}
                                        </Typography>
                                    )}
                                    <TextField
                                        fullWidth
                                        name="summary"
                                        label="Add a short summary"
                                        variant="outlined"
                                        value={this.state.projectForm.summary}
                                        onChange={this.handleFormChange}
                                        style={{ marginBottom: '16px' }}
                                        InputProps={{
                                            style: {
                                                backgroundColor: darkMode ? '#2a2a2a' : '#ffffff',
                                                color: darkMode ? '#ffffff' : '#1a202c',
                                                borderRadius: '8px'
                                            }
                                        }}
                                        inputProps={{
                                            style: { color: darkMode ? '#ffffff' : '#1a202c' }
                                        }}
                                        InputLabelProps={{
                                            style: { color: darkMode ? '#cccccc' : '#4a5568' }
                                        }}
                                    />

                                    {/* Status Chips */}
                                    <Box style={{ marginBottom: '24px' }}>
                                        <Grid container spacing={1} alignItems="center">

                                            <Grid item>
                                                <Chip
                                                    icon={<FlagIcon />}
                                                    label={this.state.projectForm.priority || 'No priority'}
                                                    size="small"
                                                    variant="outlined"
                                                    onClick={this.handleOpenPriorityPopover}
                                                    style={{ borderColor: '#1B6E95', color: '#1B6E95', cursor: 'pointer' }}
                                                />
                                            </Grid>
                                            <Grid item>
                                                <Chip
                                                    icon={<GroupIcon />}
                                                    label="Lead"
                                                    size="small"
                                                    variant="outlined"
                                                    onClick={this.handleOpenLeadPopover}
                                                    style={{ borderColor: '#1B6E95', color: '#1B6E95', cursor: 'pointer' }}
                                                />
                                            </Grid>
                                            <Grid item>
                                                <Chip
                                                    icon={<GroupIcon />}
                                                    label="Members"
                                                    size="small"
                                                    variant="outlined"
                                                    onClick={this.handleOpenMembersPopover}
                                                    style={{ borderColor: '#1B6E95', color: '#1B6E95', cursor: 'pointer' }}
                                                />
                                            </Grid>
                                            <Grid item>
                                                <Chip
                                                    icon={<PlayCircleOutlineIcon />}
                                                    label={this.state.projectForm.start_date ? `Start: ${this.state.projectForm.start_date}` : 'Start'}
                                                    size="small"
                                                    variant="outlined"
                                                    onClick={this.handleOpenStartPopover}
                                                    style={{ borderColor: '#1B6E95', color: '#1B6E95', cursor: 'pointer' }}
                                                />
                                            </Grid>
                                            <Grid item>
                                                <Chip
                                                    icon={<EventIcon />}
                                                    label={this.state.projectForm.target_date ? `Target: ${this.state.projectForm.target_date}` : 'Target'}
                                                    size="small"
                                                    variant="outlined"
                                                    onClick={this.handleOpenTargetPopover}
                                                    style={{ borderColor: '#1B6E95', color: '#1B6E95', cursor: 'pointer' }}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Box>



                                    {/* Lead and Members now controlled by chips + popovers; inputs removed */}

                                    {/* Lead Popover */}
                                    <Popover
                                        open={Boolean(this.state.leadAnchorEl)}
                                        anchorEl={this.state.leadAnchorEl}
                                        onClose={this.handleCloseLeadPopover}
                                        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                                        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                                        PaperProps={{ style: { marginTop: '10px', backgroundColor: '#ffffff', color: '#1a202c', borderRadius: 10, minWidth: 340, boxShadow: '0 10px 30px rgba(2,6,23,0.15)' } }}
                                    >
                                        <Box px={2} py={1.5} style={{ color: darkMode ? '#1B6E95' : '#334155', fontWeight: 600 }}>Select project leads (multiple allowed)</Box>
                                        <Divider />
                                        {this.state.allUsers.map((user) => {
                                            const selected = this.state.projectForm.lead_ids?.map(Number).includes(Number(user.id)) || false;
                                            const label = user.firstName ? `${user.firstName} ${user.lastName || ''}`.trim() : (user.name || user.email || `User ${user.id}`);
                                            return (
                                                <MenuItem key={user.id} value={user.id} onClick={() => {
                                                    const currentLeadIds = this.state.projectForm.lead_ids?.map(Number) || [];
                                                    const id = Number(user.id);
                                                    const exists = currentLeadIds.includes(id);
                                                    const next = exists
                                                        ? currentLeadIds.filter(sid => Number(sid) !== id)
                                                        : [...currentLeadIds, id];
                                                    this.setState({
                                                        projectForm: {
                                                            ...this.state.projectForm,
                                                            lead_ids: next,
                                                            lead_id: next.length > 0 ? next[0] : ''
                                                        }
                                                    });
                                                }} style={{ padding: '8px 12px' }}>
                                                    <Box display="flex" alignItems="center" width="100%">
                                                        <ListItemText primary={label} />
                                                        {selected ? <CheckIcon style={{ color: '#16a34a' }} /> : null}
                                                    </Box>
                                                </MenuItem>
                                            );
                                        })}
                                        <Divider />
                                        <Box p={1} display="flex" justifyContent="flex-end" gridGap={8}>
                                            <Button size="small" onClick={this.handleCloseLeadPopover}>Cancel</Button>
                                            <Button size="small" onClick={this.handleCloseLeadPopover} variant="contained" style={{ backgroundColor: '#1B6E95', color: '#fff' }}>Done</Button>
                                        </Box>
                                    </Popover>

                                    {/* Members Popover */}
                                    <Popover
                                        open={Boolean(this.state.membersAnchorEl)}
                                        anchorEl={this.state.membersAnchorEl}
                                        onClose={this.handleCloseMembersPopover}
                                        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                                        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                                        PaperProps={{ style: { marginTop: '10px', backgroundColor: '#ffffff', color: '#1a202c', borderRadius: 10, minWidth: 340, boxShadow: '0 10px 30px rgba(2,6,23,0.15)' } }}
                                    >
                                        <Box px={2} py={1.5} style={{ color: darkMode ? '#1B6E95' : '#334155', fontWeight: 600 }}>Select project members</Box>
                                        <Divider />
                                        {this.state.allUsers.map((user) => {
                                            const selected = this.state.projectForm.member_ids.map(Number).includes(Number(user.id));
                                            const label = user.firstName ? `${user.firstName} ${user.lastName || ''}`.trim() : (user.name || user.email || `User ${user.id}`);
                                            return (
                                                <MenuItem key={user.id} value={user.id} onClick={() => {
                                                    const id = Number(user.id);
                                                    const current = this.state.projectForm.member_ids.map(Number);
                                                    const exists = current.includes(id);
                                                    const next = exists
                                                        ? current.filter(sid => Number(sid) !== id)
                                                        : [...current, id];
                                                    this.setState({ projectForm: { ...this.state.projectForm, member_ids: next } });
                                                }} style={{ padding: '8px 12px' }}>
                                                    <Box display="flex" alignItems="center" width="100%">
                                                        <ListItemText primary={label} />
                                                        {selected ? <CheckIcon style={{ color: '#16a34a' }} /> : null}
                                                    </Box>
                                                </MenuItem>
                                            );
                                        })}
                                        <Divider />
                                        <Box p={1} display="flex" justifyContent="flex-end" gridGap={8}>
                                            <Button size="small" onClick={this.handleCloseMembersPopover}>Cancel</Button>
                                            <Button size="small" onClick={this.handleCloseMembersPopover} variant="contained" style={{ backgroundColor: '#1B6E95', color: '#fff' }}>Done</Button>
                                        </Box>
                                    </Popover>

                                    {/* Priority Popover */}
                                    <Popover
                                        open={Boolean(this.state.priorityAnchorEl)}
                                        anchorEl={this.state.priorityAnchorEl}
                                        onClose={this.handleClosePriorityPopover}
                                        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                                        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                                        PaperProps={{ style: { marginTop: '10px', backgroundColor: '#ffffff', color: '#1a202c', borderRadius: 10, minWidth: 240, boxShadow: '0 10px 30px rgba(2,6,23,0.15)' } }}
                                    >
                                        <Box px={2} py={1.5} style={{ color: darkMode ? '#1B6E95' : '#334155', fontWeight: 600 }}>Set priority</Box>
                                        <Divider />
                                        {['No priority', 'Low', 'Medium', 'High'].map((p) => {
                                            const selected = this.state.projectForm.priority === p;
                                            const colorMap = { 'No priority': '#94a3b8', Low: '#22c55e', Medium: '#f59e0b', High: '#ef4444' };
                                            const dotColor = colorMap[p] || '#94a3b8';
                                            return (
                                                <MenuItem key={p} value={p} onClick={() => { this.setState({ projectForm: { ...this.state.projectForm, priority: p } }); }} style={{ padding: '8px 12px' }}>
                                                    <Box display="flex" alignItems="center" width="100%">
                                                        <Box mr={1} display="flex" alignItems="center"><FiberManualRecordIcon style={{ color: dotColor }} fontSize="small" /></Box>
                                                        <ListItemText primary={p} />
                                                        {selected ? <CheckIcon style={{ color: '#16a34a' }} /> : null}
                                                    </Box>
                                                </MenuItem>
                                            );
                                        })}
                                        <Divider />
                                        <Box p={1} display="flex" justifyContent="flex-end" gridGap={8}>
                                            <Button size="small" onClick={this.handleClosePriorityPopover}>Cancel</Button>
                                            <Button size="small" onClick={this.handleClosePriorityPopover} variant="contained" style={{ backgroundColor: '#1B6E95', color: '#fff' }}>Done</Button>
                                        </Box>
                                    </Popover>

                                    {/* Start Date Popover */}
                                    <Popover
                                        open={Boolean(this.state.startAnchorEl)}
                                        anchorEl={this.state.startAnchorEl}
                                        onClose={this.handleCloseStartPopover}
                                        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                                        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                                        PaperProps={{ style: { marginTop: '10px', backgroundColor: '#ffffff', color: '#1a202c', borderRadius: 8, padding: 12, boxShadow: '0 6px 18px rgba(0,0,0,0.15)' } }}
                                    >
                                        <TextField
                                            type="date"
                                            variant="outlined"
                                            value={this.state.projectForm.start_date}
                                            onChange={(e) => this.setState({ projectForm: { ...this.state.projectForm, start_date: e.target.value } })}
                                            InputLabelProps={{ shrink: true }}
                                            InputProps={{ style: { backgroundColor: '#ffffff', color: '#1a202c', borderRadius: 8 } }}
                                        />
                                        <Box mt={1} display="flex" justifyContent="flex-end">
                                            <Button size="small" onClick={this.handleCloseStartPopover} variant="contained" style={{ backgroundColor: '#1B6E95', color: '#fff' }}>Done</Button>
                                        </Box>
                                    </Popover>

                                    {/* Target Date Popover */}
                                    <Popover
                                        open={Boolean(this.state.targetAnchorEl)}
                                        anchorEl={this.state.targetAnchorEl}
                                        onClose={this.handleCloseTargetPopover}
                                        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                                        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                                        PaperProps={{ style: { marginTop: '10px', backgroundColor: '#ffffff', color: '#1a202c', borderRadius: 8, padding: 12, boxShadow: '0 6px 18px rgba(0,0,0,0.15)' } }}
                                    >
                                        <TextField
                                            type="date"
                                            variant="outlined"
                                            value={this.state.projectForm.target_date}
                                            onChange={(e) => this.setState({ projectForm: { ...this.state.projectForm, target_date: e.target.value } })}
                                            InputLabelProps={{ shrink: true }}
                                            InputProps={{ style: { backgroundColor: '#ffffff', color: '#1a202c', borderRadius: 8 } }}
                                        />
                                        <Box mt={1} display="flex" justifyContent="flex-end">
                                            <Button size="small" onClick={this.handleCloseTargetPopover} variant="contained" style={{ backgroundColor: '#1B6E95', color: '#fff' }}>Done</Button>
                                        </Box>
                                    </Popover>

                                    {/* Priority, Start, Target now controlled by chips + popovers; inputs removed */}

                                    {/* Description */}
                                    <div style={{ border: `1px solid ${darkMode ? '#555' : '#ccc'}`, padding: '5px', minHeight: '200px', marginBottom: '24px', borderRadius: '8px' }}>
                                        <style>{`
                                            .editor-popup-fix {
                                                position: fixed !important;
                                                top: 50% !important;
                                                left: 50% !important;
                                                transform: translate(-50%, -50%) !important;
                                                z-index: 9999 !important;
                                                background-color: ${darkMode ? '#1f2937' : '#ffffff'} !important;
                                                border: 1px solid ${darkMode ? '#374151' : '#e5e7eb'} !important;
                                                box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
                                                padding: 24px !important;
                                                border-radius: 12px !important;
                                                width: 420px !important;
                                                max-width: 90vw !important;
                                                max-height: 80vh !important;
                                                overflow-y: auto !important;
                                            }
                                            .editor-popup-fix button,
                                            .editor-popup-fix input[type="button"] {
                                                font-weight: 700 !important;
                                                text-transform: uppercase !important;
                                                border-radius: 6px !important;
                                                padding: 8px 16px !important;
                                                margin-top: 20px !important;
                                                cursor: pointer !important;
                                                transition: all 0.2s !important;
                                                font-size: 12px !important;
                                                min-width: 80px !important;
                                                background-image: none !important; /* Prevent gradient interference */
                                            }
                                            
                                            /* Primary Action Button (Add) */
                                            /* We target the first button specifically, and ensure it overrides any transparency */
                                            .editor-popup-fix button:first-of-type,
                                            .editor-popup-fix input[type="button"]:first-of-type,
                                            .editor-popup-fix .rdw-link-modal-btn:first-child,
                                            .editor-popup-fix .rdw-embedded-modal-btn:first-child,
                                            .editor-popup-fix .rdw-image-modal-btn:first-child {
                                                background-color: #1B6E95 !important;
                                                color: #ffffff !important;
                                                border: 1px solid #1B6E95 !important;
                                                margin-right: 12px !important;
                                                opacity: 1 !important;
                                            }
                                            
                                            .editor-popup-fix button:first-of-type:hover,
                                            .editor-popup-fix input[type="button"]:first-of-type:hover {
                                                background-color: #155a7a !important;
                                            }

                                            /* Secondary Action Button (Cancel) */
                                            .editor-popup-fix button:last-of-type,
                                            .editor-popup-fix input[type="button"]:last-of-type,
                                            .editor-popup-fix .rdw-link-modal-btn:last-child,
                                            .editor-popup-fix .rdw-embedded-modal-btn:last-child,
                                            .editor-popup-fix .rdw-image-modal-btn:last-child {
                                                background-color: transparent !important;
                                                color: ${darkMode ? '#ffffff' : '#64748b'} !important;
                                                border: 1px solid ${darkMode ? '#4b5563' : '#cbd5e0'} !important;
                                            }

                                            .editor-popup-fix button:last-of-type:hover {
                                                background-color: ${darkMode ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.05)'} !important;
                                            }

                                            /* Inputs */
                                            .editor-popup-fix input:not([type="button"]) {
                                                background-color: ${darkMode ? '#374151' : '#ffffff'} !important;
                                                color: ${darkMode ? '#ffffff' : '#1a202c'} !important;
                                                border: 1px solid ${darkMode ? '#4b5563' : '#d1d5db'} !important;
                                                border-radius: 6px !important;
                                                padding: 10px 12px !important;
                                                margin-bottom: 16px !important;
                                                display: block !important;
                                            }
                                            .editor-popup-fix input[type="checkbox"] {
                                                width: auto !important;
                                                display: inline-block !important;
                                                margin-right: 8px !important;
                                            }
                                            .editor-popup-fix label {
                                                color: ${darkMode ? '#e5e7eb' : '#374151'} !important;
                                                font-weight: 600 !important;
                                                margin-bottom: 8px !important;
                                                display: block !important;
                                                font-size: 14px !important;
                                            }
                                        `}</style>
                                        <Editor
                                            editorState={this.state.editorState}
                                            onEditorStateChange={this.handleEditorChange}
                                            handleKeyCommand={this.handleKeyCommand}
                                            toolbar={{
                                                options: ['inline', 'blockType', 'fontSize', 'list', 'textAlign', 'link', 'embedded', 'emoji', 'image', 'remove', 'history'],
                                                inline: { inDropdown: true },
                                                list: { inDropdown: true },
                                                textAlign: { inDropdown: true },
                                                link: { inDropdown: true },
                                                embedded: { popupClassName: 'editor-popup-fix' },
                                                history: { inDropdown: true },
                                                emoji: { popupClassName: 'editor-popup-fix' },
                                                image: {
                                                    popupClassName: 'editor-popup-fix',
                                                    uploadCallback: this.uploadImageCallBack,
                                                    previewImage: true,
                                                    alt: { present: true, mandatory: false },
                                                    inputAccept: 'image/gif,image/jpeg,image/jpg,image/png,image/svg',
                                                }
                                            }}
                                            placeholder="Write a description, a project brief, or collect ideas..."
                                        />
                                    </div>

                                    {/* Milestones */}
                                    <Typography variant="h6" style={{ color: darkMode ? '#ffffff' : '#1a202c', marginBottom: '16px' }}>
                                        Create milestone
                                    </Typography>

                                    <Card variant="outlined" className="milestone-card" style={{ backgroundColor: darkMode ? '#1e1e1e' : '#ffffff', borderRadius: '8px', marginBottom: '16px', border: `1px solid ${darkMode ? '#4b5563' : '#e2e8f0'}`, boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
                                        <CardContent>
                                            {this.state.projectForm.milestones.length === 0 ? (
                                                <Typography color="textSecondary" style={{ color: darkMode ? '#cccccc' : '#64748b' }}>
                                                    No milestones yet
                                                </Typography>
                                            ) : (
                                                <List dense>
                                                    {this.state.projectForm.milestones.map((m, index) => (
                                                        <React.Fragment key={index}>
                                                            <ListItem>
                                                                <ListItemText
                                                                    primary={m.name}
                                                                    secondary={(() => {
                                                                        if (m.dueDate) return `Due ${m.dueDate}`;
                                                                        try {
                                                                            const parsed = JSON.parse(m.description || '{}');
                                                                            if (parsed && parsed.blocks) {
                                                                                return parsed.blocks.map(b => b.text || '').join('\n').trim();
                                                                            }
                                                                        } catch (_) { }
                                                                        return m.description || '';
                                                                    })()}
                                                                    primaryTypographyProps={{ style: { color: darkMode ? '#ffffff' : '#1a202c' } }}
                                                                    secondaryTypographyProps={{ style: { color: darkMode ? '#cccccc' : '#64748b', whiteSpace: 'pre-wrap' } }}
                                                                />
                                                                <ListItemSecondaryAction>
                                                                    <IconButton
                                                                        edge="end"
                                                                        aria-label="delete"
                                                                        onClick={() => this.handleRemoveMilestone(index)}
                                                                        style={{ color: darkMode ? '#cccccc' : '#475569' }}
                                                                    >
                                                                        <DeleteOutlinedIcon />
                                                                    </IconButton>
                                                                </ListItemSecondaryAction>
                                                            </ListItem>
                                                            {index < this.state.projectForm.milestones.length - 1 && <Divider style={{ backgroundColor: darkMode ? '#4b5563' : '#e2e8f0' }} />}
                                                        </React.Fragment>
                                                    ))}
                                                </List>
                                            )}

                                            {!this.state.showMilestoneForm && (
                                                <Box display="flex" justifyContent="flex-end">
                                                    <Button
                                                        onClick={() => this.setState({ showMilestoneForm: true })}
                                                        variant="contained"
                                                        style={{ backgroundColor: '#1B6E95', color: '#ffffff', textTransform: 'uppercase', fontWeight: 600 }}
                                                        startIcon={<AddIcon />}
                                                    >
                                                        Add milestone
                                                    </Button>
                                                </Box>
                                            )}

                                            {this.state.showMilestoneForm && (
                                                <div style={{ marginTop: 12, border: `1px solid ${darkMode ? '#4b5563' : '#e2e8f0'}`, borderRadius: 8, padding: 12 }}>
                                                    <Grid container spacing={2} direction="column" alignItems="stretch">
                                                        <Grid item xs={12}>
                                                            <TextField
                                                                fullWidth
                                                                label="Milestone name"
                                                                name="name"
                                                                variant="outlined"
                                                                value={this.state.milestoneDraft.name}
                                                                onChange={this.handleMilestoneDraftChange}
                                                                InputProps={{
                                                                    style: {
                                                                        backgroundColor: darkMode ? '#2a2a2a' : '#ffffff',
                                                                        color: darkMode ? '#ffffff' : '#1a202c',
                                                                        borderRadius: '8px'
                                                                    }
                                                                }}
                                                                inputProps={{
                                                                    style: { color: darkMode ? '#ffffff' : '#1a202c' }
                                                                }}
                                                                InputLabelProps={{
                                                                    style: { color: darkMode ? '#cccccc' : '#4a5568' }
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <Typography variant="subtitle2" style={{ color: darkMode ? '#cccccc' : '#64748b', fontWeight: 600, marginBottom: 6 }}>Description</Typography>
                                                            <div style={{ border: `1px solid ${darkMode ? '#555' : '#ccc'}`, padding: '5px', minHeight: '120px', borderRadius: '8px', background: darkMode ? '#1e1e1e' : '#fff' }}>
                                                                <Editor
                                                                    editorState={this.state.milestoneEditorState}
                                                                    onEditorStateChange={(s) => this.setState({ milestoneEditorState: s })}
                                                                    handleKeyCommand={this.handleKeyCommand}
                                                                    toolbar={{
                                                                        options: ['inline', 'list', 'textAlign', 'link', 'emoji', 'remove', 'history'],
                                                                        inline: { inDropdown: true },
                                                                        list: { inDropdown: true },
                                                                        textAlign: { inDropdown: true },
                                                                        link: { inDropdown: true }
                                                                    }}
                                                                    placeholder="Add a description"
                                                                />
                                                            </div>
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <TextField
                                                                fullWidth
                                                                label="Due date"
                                                                name="dueDate"
                                                                type="date"
                                                                variant="outlined"
                                                                value={this.state.milestoneDraft.dueDate}
                                                                onChange={this.handleMilestoneDraftChange}
                                                                InputProps={{
                                                                    style: {
                                                                        backgroundColor: darkMode ? '#2a2a2a' : '#ffffff',
                                                                        color: darkMode ? '#ffffff' : '#1a202c',
                                                                        borderRadius: '8px'
                                                                    }
                                                                }}
                                                                inputProps={{
                                                                    min: this.state.projectForm.target_date,
                                                                    style: { color: darkMode ? '#ffffff' : '#1a202c' }
                                                                }}
                                                                InputLabelProps={{
                                                                    shrink: true,
                                                                    style: { color: darkMode ? '#cccccc' : '#4a5568' }
                                                                }}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                    <div style={{ display: 'flex', gap: 12, marginTop: 12, justifyContent: 'flex-end' }}>
                                                        <Button
                                                            onClick={() => this.setState({ showMilestoneForm: false })}
                                                            style={{ color: '#475569', textTransform: 'uppercase', fontWeight: 600 }}
                                                        >
                                                            Cancel
                                                        </Button>
                                                        <Button
                                                            color="primary"
                                                            variant="contained"
                                                            onClick={this.handleAddMilestone}
                                                            style={{ backgroundColor: '#1B6E95', color: '#ffffff', textTransform: 'uppercase', fontWeight: 700 }}
                                                        >
                                                            Add milestone
                                                        </Button>
                                                    </div>
                                                </div>
                                            )}
                                        </CardContent>
                                    </Card>
                                </form>
                            </DialogContent>

                            <DialogActions className="dialog-actions" style={{
                                padding: '16px 24px',
                                borderTop: `1px solid ${darkMode ? '#4b5563' : '#e2e8f0'}`,
                                justifyContent: 'flex-end',
                                borderBottomLeftRadius: 8,
                                borderBottomRightRadius: 8
                            }}>
                                <Button
                                    onClick={this.handleCloseAddModal}
                                    style={{ marginRight: '8px' }}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    onClick={this.handleSubmitProject}
                                    variant="contained"
                                    style={{ backgroundColor: '#1B6E95', color: '#ffffff' }}
                                    disabled={this.state.isSubmitting}
                                >
                                    Create project
                                </Button>
                            </DialogActions>
                        </Dialog>
                    )}
                </ThemeContext.Consumer>

                {/* Inline Editing Popovers */}
                {/* Inline Status Popover */}
                <ThemeContext.Consumer>
                    {({ darkMode }) => (
                        <Popover
                            open={Boolean(this.state.inlineStatusAnchorEl)}
                            anchorEl={this.state.inlineStatusAnchorEl}
                            onClose={this.handleCloseInlinePopover}
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                            PaperProps={{ style: { backgroundColor: darkMode ? '#1e1e1e' : '#ffffff', color: darkMode ? '#ffffff' : '#1a202c', borderRadius: 10, minWidth: 260, boxShadow: '0 10px 30px rgba(2,6,23,0.15)' } }}
                        >
                            <Box px={2} py={1.5} style={{ color: darkMode ? '#ffffff' : '#334155', fontWeight: 600 }}>Select status</Box>
                            <Divider style={{ backgroundColor: darkMode ? '#4b5563' : '#e2e8f0' }} />
                            {['Backlog', 'Planned', 'In Progress', 'Completed', 'Canceled'].map((opt) => {
                                const selected = this.state.pendingChanges.status === opt;
                                const colorMap = { Backlog: '#64748b', Planned: '#eab308', 'In Progress': '#3b82f6', Completed: '#22c55e', Canceled: '#9ca3af' };
                                const dotColor = colorMap[opt] || '#64748b';
                                return (
                                    <MenuItem key={`list-status-${opt}`} value={opt} onClick={() => this.handlePendingChange('status', opt)} style={{ padding: '8px 12px', color: darkMode ? '#ffffff' : '#1a202c' }}>
                                        <Box display="flex" alignItems="center" width="100%">
                                            <Box mr={1} display="flex" alignItems="center"><FiberManualRecordIcon style={{ color: dotColor }} fontSize="small" /></Box>
                                            <ListItemText primary={opt} />
                                            {selected ? <CheckIcon style={{ color: '#16a34a' }} /> : null}
                                        </Box>
                                    </MenuItem>
                                );
                            })}
                            <Divider style={{ backgroundColor: darkMode ? '#4b5563' : '#e2e8f0' }} />
                            <Box p={1} display="flex" justifyContent="flex-end" gridGap={8}>
                                <Button size="small" onClick={this.handleCancelPendingChanges} style={{ color: darkMode ? '#ffffff' : '#1a202c' }}>Cancel</Button>
                                <Button size="small" onClick={this.handleSavePendingChanges} variant="contained" style={{ backgroundColor: '#1B6E95', color: '#ffffff' }}>Save</Button>
                            </Box>
                        </Popover>
                    )}
                </ThemeContext.Consumer>

                {/* Inline Priority Popover */}
                <ThemeContext.Consumer>
                    {({ darkMode }) => (
                        <Popover
                            open={Boolean(this.state.inlinePriorityAnchorEl)}
                            anchorEl={this.state.inlinePriorityAnchorEl}
                            onClose={this.handleCloseInlinePopover}
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                            PaperProps={{ style: { backgroundColor: darkMode ? '#1e1e1e' : '#ffffff', color: darkMode ? '#ffffff' : '#1a202c', borderRadius: 10, minWidth: 240, boxShadow: '0 10px 30px rgba(2,6,23,0.15)' } }}
                        >
                            <Box px={2} py={1.5} style={{ color: darkMode ? '#ffffff' : '#334155', fontWeight: 600 }}>Select priority</Box>
                            <Divider style={{ backgroundColor: darkMode ? '#4b5563' : '#e2e8f0' }} />
                            {['No priority', 'Low', 'Medium', 'High'].map((p) => {
                                const selected = this.state.pendingChanges.priority === p;
                                const colorMap = { 'No priority': '#94a3b8', Low: '#22c55e', Medium: '#f59e0b', High: '#ef4444' };
                                const dotColor = colorMap[p] || '#94a3b8';
                                return (
                                    <MenuItem key={p} value={p} onClick={() => this.handlePendingChange('priority', p)} style={{ padding: '8px 12px', color: darkMode ? '#ffffff' : '#1a202c' }}>
                                        <Box display="flex" alignItems="center" width="100%">
                                            <Box mr={1} display="flex" alignItems="center"><FiberManualRecordIcon style={{ color: dotColor }} fontSize="small" /></Box>
                                            <ListItemText primary={p} />
                                            {selected ? <CheckIcon style={{ color: '#16a34a' }} /> : null}
                                        </Box>
                                    </MenuItem>
                                );
                            })}
                            <Divider style={{ backgroundColor: darkMode ? '#4b5563' : '#e2e8f0' }} />
                            <Box p={1} display="flex" justifyContent="flex-end" gridGap={8}>
                                <Button size="small" onClick={this.handleCancelPendingChanges} style={{ color: darkMode ? '#ffffff' : '#1a202c' }}>Cancel</Button>
                                <Button size="small" onClick={this.handleSavePendingChanges} variant="contained" style={{ backgroundColor: '#1B6E95', color: '#ffffff' }}>Save</Button>
                            </Box>
                        </Popover>
                    )}
                </ThemeContext.Consumer>

                {/* Inline Lead Popover */}
                <ThemeContext.Consumer>
                    {({ darkMode }) => (
                        <Popover
                            open={Boolean(this.state.inlineLeadAnchorEl)}
                            anchorEl={this.state.inlineLeadAnchorEl}
                            onClose={this.handleCloseInlinePopover}
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                            PaperProps={{ style: { backgroundColor: darkMode ? '#1e1e1e' : '#ffffff', color: darkMode ? '#ffffff' : '#1a202c', borderRadius: 10, minWidth: 340, boxShadow: '0 10px 30px rgba(2,6,23,0.15)' } }}
                        >
                            <Box px={2} py={1.5} style={{ color: darkMode ? '#ffffff' : '#334155', fontWeight: 600 }}>Select project leads (multiple allowed)</Box>
                            <Divider style={{ backgroundColor: darkMode ? '#4b5563' : '#e2e8f0' }} />
                            {this.state.allUsers.map((user) => {
                                const selected = this.state.pendingChanges.lead_ids?.map(Number).includes(Number(user.id)) || false;
                                return (
                                    <MenuItem key={user.id} value={user.id} onClick={() => {
                                        const currentLeadIds = this.state.pendingChanges.lead_ids?.map(Number) || [];
                                        const id = Number(user.id);
                                        const exists = currentLeadIds.includes(id);
                                        const next = exists
                                            ? currentLeadIds.filter(sid => Number(sid) !== id)
                                            : [...currentLeadIds, id];
                                        console.log('Lead selection changed:', { currentLeadIds, id, exists, next });
                                        this.handlePendingChange('lead_ids', next);
                                    }} style={{ padding: '8px 12px', color: darkMode ? '#ffffff' : '#1a202c' }}>
                                        <Box display="flex" alignItems="center" width="100%">
                                            <ListItemText primary={user.firstName ? `${user.firstName} ${user.lastName || ''}`.trim() : (user.name || user.email || `User ${user.id}`)} />
                                            {selected ? <CheckIcon style={{ color: '#16a34a' }} /> : null}
                                        </Box>
                                    </MenuItem>
                                );
                            })}
                            <Divider style={{ backgroundColor: darkMode ? '#4b5563' : '#e2e8f0' }} />
                            <Box p={1} display="flex" justifyContent="flex-end" gridGap={8}>
                                <Button size="small" onClick={this.handleCancelPendingChanges} style={{ color: darkMode ? '#ffffff' : '#1a202c' }}>Cancel</Button>
                                <Button size="small" onClick={this.handleSavePendingChanges} variant="contained" style={{ backgroundColor: '#1B6E95', color: '#ffffff' }}>Save</Button>
                            </Box>
                        </Popover>
                    )}
                </ThemeContext.Consumer>

                {/* Inline Members Popover */}
                <ThemeContext.Consumer>
                    {({ darkMode }) => (
                        <Popover
                            open={Boolean(this.state.inlineMembersAnchorEl)}
                            anchorEl={this.state.inlineMembersAnchorEl}
                            onClose={this.handleCloseInlinePopover}
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                            PaperProps={{ style: { backgroundColor: darkMode ? '#1e1e1e' : '#ffffff', color: darkMode ? '#ffffff' : '#1a202c', borderRadius: 10, minWidth: 340, boxShadow: '0 10px 30px rgba(2,6,23,0.15)' } }}
                        >
                            <Box px={2} py={1.5} style={{ color: darkMode ? '#ffffff' : '#334155', fontWeight: 600 }}>Select project members</Box>
                            <Divider style={{ backgroundColor: darkMode ? '#4b5563' : '#e2e8f0' }} />
                            {this.state.allUsers.map((user) => {
                                const selected = this.state.pendingChanges.member_ids?.map(Number).includes(Number(user.id)) || false;
                                return (
                                    <MenuItem key={user.id} value={user.id} onClick={() => {
                                        const currentMemberIds = this.state.pendingChanges.member_ids?.map(Number) || [];
                                        const id = Number(user.id);
                                        const exists = currentMemberIds.includes(id);
                                        const next = exists
                                            ? currentMemberIds.filter(sid => Number(sid) !== id)
                                            : [...currentMemberIds, id];
                                        this.handlePendingChange('member_ids', next);
                                    }} style={{ padding: '8px 12px', color: darkMode ? '#ffffff' : '#1a202c' }}>
                                        <Box display="flex" alignItems="center" width="100%">
                                            <ListItemText primary={user.firstName ? `${user.firstName} ${user.lastName || ''}`.trim() : (user.name || user.email || `User ${user.id}`)} />
                                            {selected ? <CheckIcon style={{ color: '#16a34a' }} /> : null}
                                        </Box>
                                    </MenuItem>
                                );
                            })}
                            <Divider style={{ backgroundColor: darkMode ? '#4b5563' : '#e2e8f0' }} />
                            <Box p={1} display="flex" justifyContent="flex-end" gridGap={8}>
                                <Button size="small" onClick={this.handleCancelPendingChanges} style={{ color: darkMode ? '#ffffff' : '#1a202c' }}>Cancel</Button>
                                <Button size="small" onClick={this.handleSavePendingChanges} variant="contained" style={{ backgroundColor: '#1B6E95', color: '#ffffff' }}>Save</Button>
                            </Box>
                        </Popover>
                    )}
                </ThemeContext.Consumer>

                {/* Inline Target Date Popover */}
                <Popover
                    open={Boolean(this.state.inlineTargetAnchorEl)}
                    anchorEl={this.state.inlineTargetAnchorEl}
                    onClose={this.handleCloseInlinePopover}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                    PaperProps={{ style: { backgroundColor: '#ffffff', color: '#1a202c', borderRadius: 8, padding: 12, boxShadow: '0 6px 18px rgba(0,0,0,0.15)' } }}
                >
                    <Box mb={1} style={{ color: '#4a5568', fontWeight: 600 }}>Set Target Date</Box>
                    <TextField
                        type="date"
                        variant="outlined"
                        value={this.state.pendingChanges.target_date || ''}
                        onChange={(e) => this.handlePendingChange('target_date', e.target.value)}
                        InputLabelProps={{ shrink: true }}
                        InputProps={{ style: { backgroundColor: '#ffffff', color: '#1a202c', borderRadius: 8 } }}
                    />
                    <Box mt={2} display="flex" justifyContent="flex-end" gridGap={8}>
                        <Button size="small" onClick={this.handleCancelPendingChanges} style={{ color: '#64748b' }}>
                            Cancel
                        </Button>
                        <Button
                            size="small"
                            onClick={this.handleSavePendingChanges}
                            variant="contained"
                            style={{ backgroundColor: '#1B6E95', color: '#ffffff' }}
                        >
                            Save
                        </Button>
                    </Box>
                </Popover>
            </div >
        )
    }
}

export default ProjectList;